import { Component, OnDestroy } from '@angular/core';
import { ThemeService, ThemeMode } from '../../../service/theme.service';
import { PersonalizationService, AppearanceToken } from '../../../service/personalization.service';

@Component({
  selector: 'app-appearance-setting',
  templateUrl: './appearance-setting.component.html',
  styleUrls: ['./appearance-setting.component.scss'],
})
export class AppearanceSettingComponent implements OnDestroy {

  // The Live Preview buttons are for demoing colours only — not wired to anything.
  // Clicking one flashes a small tooltip above it so users know it's not real.
  demoPoke: 'save' | 'cancel' | null = null;
  private demoTimer: any;

  readonly modes: { value: ThemeMode; label: string; icon: string; hint: string }[] = [
    { value: 'system', label: 'System', icon: 'contrast', hint: 'Match your device' },
    { value: 'light', label: 'Light', icon: 'light_mode', hint: 'Always light' },
    { value: 'dark', label: 'Dark', icon: 'dark_mode', hint: 'Always dark' },
  ];

  constructor(
    public themeService: ThemeService,
    public personalization: PersonalizationService,
  ) {}

  get tokens(): AppearanceToken[] { return this.personalization.tokens; }

  /** Current colour for the swatch: user override, else the theme's default. */
  swatch(t: AppearanceToken): string {
    return this.personalization.get(t.key) || (this.themeService.isDark ? t.defaultDark : t.defaultLight);
  }

  onColor(t: AppearanceToken, value: string): void {
    this.personalization.setColor(t.key, value);
  }

  onHexInput(t: AppearanceToken, value: string): void {
    let v = (value || '').trim();
    if (v && v[0] !== '#') { v = '#' + v; }
    if (/^#[0-9a-fA-F]{6}$/.test(v)) { this.personalization.setColor(t.key, v); }
  }

  reset(t: AppearanceToken): void { this.personalization.resetColor(t.key); }
  resetAll(): void { this.personalization.resetAll(); }
  setMode(m: ThemeMode): void { this.themeService.setMode(m); }

  /** Flash a "this is only a preview" tooltip above a demo button. */
  pokeDemo(which: 'save' | 'cancel'): void {
    this.demoPoke = which;
    clearTimeout(this.demoTimer);
    this.demoTimer = setTimeout(() => { this.demoPoke = null; }, 2200);
  }

  ngOnDestroy(): void { clearTimeout(this.demoTimer); }
}
